import { createI18n } from 'vue-i18n'
import messages from '@intlify/unplugin-vue-i18n/messages'

export const SUPPORTED_LANGUAGES = ['nl', 'en', 'de'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const SUPPORTED_NUMBER_FORMATS = ['currency'] as const
export type SupportedNumberFormat = (typeof SUPPORTED_NUMBER_FORMATS)[number]
type NumberFormats = Record<
  SupportedLanguage,
  Record<SupportedNumberFormat, Intl.NumberFormatOptions>
>

export const i18n = createI18n({
  locale:
    navigator.languages.find((lang) => SUPPORTED_LANGUAGES.includes(lang as SupportedLanguage)) ||
    'nl',
  fallbackLocale: 'en',
  legacy: false, // using Composition API
  messages,
  missingWarn: false,
  fallbackWarn: false,
  numberFormats: {
    en: { currency: { style: 'currency', currency: 'EUR', notation: 'standard' } },
    nl: { currency: { style: 'currency', currency: 'EUR', notation: 'standard' } },
    de: { currency: { style: 'currency', currency: 'EUR', notation: 'standard' } }
  } satisfies NumberFormats
})
